import React, { useState, useRef, useEffect } from "react";
import "./App.css";
import creativity from "./assets/creativity.png";
import projects from "./assets/projects.png";
import exp from "./assets/exp.png";
import starting from "./assets/starting.png";
import status from "./assets/project-status.png";
import mario from "./assets/mario.png";
import marioAudio from "./assets/mario_jump.mp3";
import letterOpening from "./assets/letter.mp3";
import cv from "./assets/cv.png";
import copy from "./assets/copy.png";
import click from "./assets/mouseclick.mp3";
import Github from "./assets/github.png";
import rocket from "./assets/startup.png";
import socialIcon from "./assets/social-media.png";
import link from "./assets/link-building.png";
import resume from "./assets/resume.png";

function App() {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  const [copied, setCopied] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dragAudioRef = useRef(new Audio(letterOpening));
  const clickAudioRef = useRef(new Audio(click));
  const roadmapBoxRef = useRef(null);
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024); // 1024px breakpoint for desktop
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const smallInfo = {
    name: "Ooops! This is a small screen",
    mentions: [
      "Please use a laptop to view the portfolio",
      "Kanban style inspired portfolio",
    ],
  };

  const info = {
    name: "Sankalp Pandey ",
    CV: "https://drive.google.com/file/d/1UC6LI62USnGqEtZwE2hR8UH2pA01ZpXY/view?usp=sharing",
    role: "Software Development Engineer",
    portfolioStyle: "Kanban style inspired portfolio",
    mentions: ["Developer", "FC Barcelona", "Gym", "Kanban Portfolio"],
  };

  const labels = [
    {
      name: "Experience",
      className: "exp",
      icon: exp,
      content: [
        {
          col: 0,
          type: "card",
          text: "SDE at Stryker",
          tags: ["Current", "SDE", "Fullstack", "Gurugram"],
          link: "https://www.stryker.com/it/en/index.html",
        },
        {
          col: 3, // This is the target card
          type: "card",
          text: "Frontend Intern at Applied Computing",
          tags: ["Previous", "Frontend Intern", "Remote"],
        },
        {
          col: 5,
          type: "card",
          text: "Full Stack Intern at bXtended",
          tags: ["Previous", "Fullstack Intern", "Remote"],
        },
      ],
    },
    {
      name: "Projects",
      className: "per",
      icon: starting,
      content: [
        {
          col: 0,
          type: "card",
          text: "Animal Welfare API Backend",
          tags: [
            "Animal Care",
            "Node.js",
            "Express",
            "MongoDB",
            "Backend",
            "Geolocation",
            "API Efficiency",
          ],
          github: "https://github.com/SANKALP1011/AnimalHelperApi",
          live: "https://www.postman.com/martian-meteor-817492/animal-welfare-api/collection/kquwuua/animal-welfare-api?action=share&creator=24017825",
        },
        {
          col: 2,
          type: "card",
          text: "Animal Welfare Mobile App",
          tags: [
            "Animal Care",
            "React Native",
            "Mobile App",
            "Context API",
            "Async Storage",
            "Frontend",
          ],
          github: "https://github.com/SANKALP1011/AnimalWelfareApp",
          live: "https://drive.google.com/drive/folders/1E7XhKvfEH386YNy--kXZvzjGkfGqLfAl?usp=sharing",
        },
        {
          col: 4,
          type: "card",
          text: "Version Manager API Backend",
          tags: [
            "GitHub Profile",
            "Node.js",
            "Express",
            "MongoDB",
            "Passport.js",
            "JWT Auth",
            "Backend",
          ],
          github: "https://github.com/SANKALP1011/VersionManager",
          live: "https://www.postman.com/martian-meteor-817492/workspace/version-analysis/collection/24017825-702a4f33-fb25-43e4-8bfa-8283ef7c6c3d?action=share&creator=24017825",
        },
        {
          col: 6,
          type: "card",
          text: "Version Manager API Docs",
          tags: [
            "API Documentation",
            "Docusaurus",
            "JavaScript",
            "Mermaid.js",
            "Developer Tool",
            "Frontend",
          ],
          github: "https://github.com/SANKALP1011/version-manager-docs",
          live: "https://version-manager-docs.vercel.app/",
        },
        {
          col: 8,
          type: "card",
          text: "Version Manager Dashboard",
          tags: [
            "Dashboard",
            "Next.js",
            "TypeScript",
            "Data Visualization",
            "Frontend",
            "Charts",
          ],
          github: "https://github.com/SANKALP1011/version-dashboard",
          live: "https://drive.google.com/drive/folders/1AHZpUammM2IaJ20kgfpZKLpsGJWma3gq",
        },
        {
          col: 10,
          type: "card",
          text: "Logger",
          tags: [
            "Backend",
            "Node.js",
            "JavaScript",
            "MongoDB",
            "Express",
            "Analytics",
            "API",
            "cli",
            "commander",
          ],
          github: "https://github.com/SANKALP1011/Log-Ingester",
          live: "https://www.postman.com/martian-meteor-817492/workspace/logger",
        },
        {
          col: 12,
          type: "card",
          text: "Solar Backend",
          tags: [
            "Backend",
            "Go",
            "Fibre",
            "Postman",
            "Nasa Api",
            "Nasa APOD",
            "API",
          ],
          github: "https://github.com/SANKALP1011/SolarSearcherBackend",
          live: "https://documenter.getpostman.com/view/24017825/2s9Ykkf3as",
        },
      ],
    },
    {
      name: "Skills",
      className: "pro",
      icon: creativity,
      content: [
        {
          col: 0,
          type: "card",
          text: "Languages",
          tags: [
            "JavaScript",
            "C#",
            "TypeScript",
            "SQL",
            "GO",
            "C++",

            "Xamarin",
            "Swift",
            "Shell Scripting",
            "HTML",
            "CSS",
            "Python",
          ],
        },
        {
          col: 2,
          type: "card",
          text: "Frameworks",
          tags: [
            "React",
            "Angular",
            "Node.js",
            "Express",
            ".NET",
            "MAUI",
            "Xamarin.Forms",
            "Blazor",
            "Next",
            "React Native",
            "Fiber",
            "Nest.js",
          ],
        },
        {
          col: 4,
          type: "card",
          text: "Databases",
          tags: [
            "MySQL",
            "MongoDB",
            "PostgreSQL",
            "Azure Cosmos DB",
            "SQLite",
            "Sql Server",
          ],
        },
        {
          col: 6,
          type: "card",
          text: "Cloud and DevOps",
          tags: [
            "Azure",
            "Docker",
            "CI/CD",
            "Azure AD",
            "Multiple Azure Services",
            "Firebase",
            "Git",
            "GitHub Actions",
            "Github",
          ],
        },
        {
          col: 8,
          type: "card",
          text: "Deployement",
          tags: [
            "Azure App services",
            "Heroku",
            "Netlify",
            "Vercel",
            "GitHub Pages",
            "Firebase Hosting",
          ],
        },
      ],
    },
    {
      name: "Education",
      className: "skills",
      icon: status,
      content: [
        {
          col: 2,
          type: "card",
          text: "Dual Degree",
          tags: [
            "VIT Vellore",
            "BTech and MTech dual degree",
            "CSE",
            "CGPA: 8.61",
          ],
        },
        {
          col: 4,
          type: "card",
          text: "Delhi Public School",
          tags: ["HighSchool", "Senio Secondary", "Science", "91.8%"],
        },
      ],
    },
    {
      name: "Socials",
      className: "education",
      icon: projects,
      content: [
        {
          col: 1,
          type: "card",
          text: "LinkedIn",
          tags: ["Connect on LinkedIn"],
          link: "https://www.linkedin.com/in/sankalp-pandey-688a28223/",
        },
        {
          col: 3,
          type: "card",
          text: "GitHub",
          tags: [
            "Check out my Github profile",
            "projects",
            "api",
            "fullstack",
            "frontend",
          ],
          link: "https://github.com/SANKALP1011",
        },
        {
          col: 5,
          type: "card",
          text: "Bento",
          tags: ["Bento profile just for fun", "Social"],
          link: "https://bento.me/sankalp1011",
        },
        {
          col: 7,
          type: "card",
          text: "Portfolio v1",
          tags: ["old portfolio", "dark theme", "detailed"],
          link: "https://portfolio-site-sankalp1011.vercel.app/",
        },
      ],
    },
  ];

  const gridDays = 14;
  const [dragData, setDragData] = useState({ dx: 0, dy: 0, dragging: null });

  const handleDragStart = (e, rowIndex, colIndex) => {
    e.preventDefault(); // Prevents default text selection
    document.body.classList.add("noselect");

    const audio = dragAudioRef.current;
    if (audio) {
      audio.currentTime = 0;
      audio.play().catch((error) => {
        // Optional: log or handle the play error
        console.warn("Audio play was interrupted:", error);
      });
    }

    setDragData({
      dragging: `${rowIndex}-${colIndex}`,
      startX: e.clientX,
      startY: e.clientY,
      dx: 0,
      dy: 0,
    });
  };

  const handleDrag = (e) => {
    if (dragData.dragging) {
      setDragData((prev) => ({
        ...prev,
        dx: e.clientX - prev.startX,
        dy: e.clientY - prev.startY,
      }));
    }
  };

  const handleDragEnd = () => {
    const audio = dragAudioRef.current;
    if (audio && !audio.paused) {
      audio.pause();
      audio.currentTime = 0;
    }

    document.body.classList.remove("noselect");
    setDragData({ dx: 0, dy: 0, dragging: null });
  };
  const handleCopy = (e) => {
    e.preventDefault(); // Prevents default anchor behavior

    const audio = clickAudioRef.current;

    if (audio) {
      audio.currentTime = 0; // Restart from beginning
      audio.play().catch((err) => console.error("Audio play failed", err));

      audio.onended = () => {
        audio.pause();
        audio.currentTime = 0; // Reset to start
      };
    }

    navigator.clipboard.writeText("sankalp.pandey1011@gmail.com").then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handdleCVCopy = (e) => {
    const audio = clickAudioRef.current;

    if (audio) {
      audio.currentTime = 0; // Restart from beginning
      audio.play().catch((err) => console.error("Audio play failed", err));

      audio.onended = () => {
        audio.pause();
        audio.currentTime = 0; // Reset to start
      };
    }
  };

  const playClickAudio = () => {
    const audio = clickAudioRef.current;
    if (audio) {
      audio.currentTime = 0;
      audio.play().catch((err) => console.error("audio play failed", err));
      audio.onended = () => {
        audio.pause();
        audio.currentTime = 0;
      };
    }
  };

  // Returns true if a card's text or tags match the current search term.
  // Empty search term means everything matches (no filter applied).
  const matchesSearch = (item) => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return true;
    if (item?.text?.toLowerCase().includes(term)) return true;
    if (item?.tags?.some((tag) => tag.toLowerCase().includes(term))) {
      return true;
    }
    return false;
  };

  // Clicking a tag filters the whole board to that tag.
  // Clicking the same tag again clears the filter.
  const handleTagClick = (e, tag) => {
    e.stopPropagation();
    playClickAudio();
    setSearchTerm((prev) =>
      prev.trim().toLowerCase() === tag.toLowerCase() ? "" : tag,
    );
  };

  // Wraps the portion of `text` that matches the current search term in a
  // <mark> so matches are highlighted inline, not just left to the
  // dim/bright opacity treatment on the whole card.
  const renderHighlighted = (text) => {
    const term = searchTerm.trim();
    if (!term || typeof text !== "string") return text;
    const idx = text.toLowerCase().indexOf(term.toLowerCase());
    if (idx === -1) return text;
    return (
      <>
        {text.slice(0, idx)}
        <mark className="search-highlight">
          {text.slice(idx, idx + term.length)}
        </mark>
        {text.slice(idx + term.length)}
      </>
    );
  };

  const totalCards = labels.reduce(
    (sum, label) => sum + (label.content?.length || 0),
    0,
  );
  const matchCount = labels.reduce(
    (sum, label) =>
      sum + (label.content?.filter((item) => matchesSearch(item)).length || 0),
    0,
  );

  // When the search term changes, scroll the board so the earliest
  // matching card is actually visible instead of leaving it off-screen
  // to the right while everything visible dims out.
  useEffect(() => {
    const term = searchTerm.trim();
    if (!term || !roadmapBoxRef.current) return;

    let minCol = null;
    labels.forEach((label) => {
      label.content?.forEach((item) => {
        if (
          typeof item?.col === "number" &&
          matchesSearch(item) &&
          (minCol === null || item.col < minCol)
        ) {
          minCol = item.col;
        }
      });
    });

    if (minCol !== null) {
      const columnWidth = 160; // matches .grid-cell width in App.css
      // Leave one column of breathing room before the match instead of
      // pinning it flush against the sticky row label.
      const targetScroll = Math.max(0, (minCol - 1) * columnWidth);
      roadmapBoxRef.current.scrollTo({
        left: targetScroll,
        behavior: "smooth",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  return (
    <div className="app" onMouseMove={handleDrag} onMouseUp={handleDragEnd}>
      {!isDesktop ? (
        <div className="smallScreenDiv">
          <img src={mario} className="mario-jump" alt="Jumping Mario" />
          <div className="small-screen-card" id="smallCard">
            <div className="card-header">{smallInfo.name}</div>
            <div className="card-tags">
              {smallInfo.mentions.map((mention, idx) => (
                <span key={idx} className="tag skill">
                  {mention}
                </span>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="top-row">
            <div className="info-card">
              <div className="card-header">
                {info.name}{" "}
                <a href="" onClick={handleCopy}>
                  <img className="cv-image" src={copy} />
                </a>
                {copied && (
                  <div className="copy-notification">Copied Email ID</div>
                )}
                <a href={info.CV} onClick={handdleCVCopy} target="_blank">
                  <img className="resume-image" src={cv} />
                </a>
              </div>

              <div className="card-tags">
                {info.mentions.map((mention, idx) => (
                  <span key={idx} className="tag skill">
                    {mention}
                  </span>
                ))}
              </div>

              {/* 📍 Gurugram, India map */}
            </div>

            <div className="filter-bar">
              <input
                type="text"
                className="filter-input"
                placeholder="Search projects, skills, tags..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm && (
                <>
                  <span className="filter-count">
                    {matchCount} of {totalCards} cards
                  </span>
                  <button
                    className="filter-clear"
                    onClick={() => setSearchTerm("")}
                  >
                    Clear ×
                  </button>
                </>
              )}
            </div>
          </div>

          <div className="roadmap-box" ref={roadmapBoxRef}>
            <div className="roadmap-grid">
              {labels.map((label, rowIndex) => (
                <React.Fragment key={label.name}>
                  <div className={`section-label ${label.className}`}>
                    {label.name}
                    {label.icon && (
                      <img
                        src={label.icon}
                        alt={`${label.name} icon`}
                        className="label-icon"
                      />
                    )}
                  </div>
                  {[...Array(gridDays)].map((_, colIndex) => {
                    const item = label.content?.find((c) => c.col === colIndex);
                    const isDragging =
                      dragData.dragging === `${rowIndex}-${colIndex}`;
                    const transformStyle = isDragging
                      ? {
                          transform: `translate(${dragData.dx}px, ${dragData.dy}px)`,
                          zIndex: 10,
                        }
                      : {};

                    // Determine if this is the specific card we want to target
                    const isTargetCard =
                      label.name === "Experience" &&
                      item?.text === "Frontend Intern at Applied Computing";

                    // A second hand-drawn hint, this time pointing at a tag
                    // to showcase that tags are clickable filters.
                    const isFilterHintCard =
                      label.name === "Skills" && item?.text === "Languages";

                    const isMatch = item ? matchesSearch(item) : true;

                    return (
                      <div
                        className="grid-cell"
                        key={`cell-${rowIndex}-${colIndex}`}
                      >
                        {item?.type === "card" && (
                          <div
                            className="small-card"
                            onMouseDown={(e) =>
                              handleDragStart(e, rowIndex, colIndex)
                            }
                            style={{
                              ...transformStyle,
                              opacity: isMatch ? 1 : 0.25,
                              filter: isMatch ? "none" : "grayscale(70%)",
                              cursor: "grab",
                              borderBottomColor:
                                label.className === "exp"
                                  ? "#483AA0"
                                  : label.className === "per"
                                    ? "#DD88CF"
                                    : label.className === "skills"
                                      ? "#732255"
                                      : label.className === "education"
                                        ? "#8F87F1"
                                        : label.className === "socials"
                                          ? "#80D8FF"
                                          : label.className === "pro"
                                            ? "#F26B0F"
                                            : "#4ED7F1",
                              borderLeftColor:
                                label.className === "exp"
                                  ? "#483AA0"
                                  : label.className === "per"
                                    ? "#DD88CF"
                                    : label.className === "skills"
                                      ? "#732255"
                                      : label.className === "education"
                                        ? "#8F87F1"
                                        : label.className === "socials"
                                          ? "#80D8FF"
                                          : label.className === "pro"
                                            ? "#F26B0F"
                                            : "#4ED7F1",
                            }}
                          >
                            <div className="card-title">
                              {renderHighlighted(item.text)}{" "}
                            </div>
                            {item.description && (
                              <div className="card-description">
                                {item.description}
                              </div>
                            )}
                            <div className="card-tags">
                              {label.name === "Experience" && (
                                <>
                                  {item.tags?.map((tag, idx) => (
                                    <span
                                      key={idx}
                                      className={`tag ${tag.toLowerCase()}`}
                                      onClick={(e) => handleTagClick(e, tag)}
                                    >
                                      {renderHighlighted(tag)}
                                      {tag === "Current" && (
                                        <span className="blinking-dot" />
                                      )}
                                    </span>
                                  ))}

                                  {item.link && (
                                    <a
                                      href={item.link}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="tag link"
                                      onClick={playClickAudio}
                                    >
                                      <img
                                        src={link}
                                        alt="Link"
                                        className="social-icon"
                                      />
                                    </a>
                                  )}
                                </>
                              )}
                              {label.name === "Projects" && (
                                <>
                                  {item.tags?.map((tag, idx) => (
                                    <span
                                      key={idx}
                                      className="tag projects"
                                      onClick={(e) => handleTagClick(e, tag)}
                                    >
                                      {renderHighlighted(tag)}
                                    </span>
                                  ))}
                                  {item.github && (
                                    <a
                                      href={item.github}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="tag current"
                                      onClick={playClickAudio}
                                    >
                                      <img
                                        src={Github}
                                        alt="GitHub"
                                        className="git-icon"
                                      />
                                    </a>
                                  )}
                                  {item.live && (
                                    <a
                                      href={item.live}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="tag skill"
                                      onClick={playClickAudio}
                                    >
                                      <img
                                        src={rocket}
                                        alt="live"
                                        className="git-icon"
                                      />
                                    </a>
                                  )}
                                </>
                              )}
                              {label.name === "Skills" && (
                                <>
                                  {item.tags?.map((tag, idx) => (
                                    <span
                                      key={idx}
                                      className="tag skill"
                                      onClick={(e) => handleTagClick(e, tag)}
                                    >
                                      {renderHighlighted(tag)}
                                    </span>
                                  ))}
                                </>
                              )}
                              {label.name === "Education" && (
                                <>
                                  {item.tags?.map((tag, idx) => (
                                    <span
                                      key={idx}
                                      className="tag education-tag"
                                      onClick={(e) => handleTagClick(e, tag)}
                                    >
                                      {renderHighlighted(tag)}
                                    </span>
                                  ))}
                                </>
                              )}
                              {label.name === "Socials" && (
                                <>
                                  {item.tags?.map((tag, idx) => (
                                    <span
                                      key={idx}
                                      className="tag projects"
                                      onClick={(e) => handleTagClick(e, tag)}
                                    >
                                      {renderHighlighted(tag)}
                                    </span>
                                  ))}
                                  {item.link && (
                                    <a
                                      href={item.link}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="tag current"
                                      onClick={playClickAudio}
                                    >
                                      <img
                                        src={link}
                                        alt="Social"
                                        className="social-icon"
                                      />
                                    </a>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        )}
                        {isTargetCard && (
                          // Add arrow and cloud next to the target card
                          <>
                            <svg
                              className="hand-drawn-arrow-svg"
                              viewBox="0 0 100 100"
                              preserveAspectRatio="xMidYMid meet"
                            >
                              <path
                                d="M 30 90 Q 60 90, 30 100 Q 40 60, 50 50 L 85 15" // main line of the arrow
                                stroke="#FF0B55" // Match info-card border color
                                strokeWidth="4"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{
                                  filter:
                                    "drop-shadow(1px 1px 1px rgba(0,0,0,0.2))",
                                }}
                              />
                              <path
                                d="M 85 15 L 75 25 M 85 15 L 75 5" // Arrowhead
                                stroke="#FF0B55" // Match info-card border color
                                strokeWidth="4"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{
                                  filter:
                                    "drop-shadow(1px 1px 1px rgba(0,0,0,0.2))",
                                }}
                              />
                            </svg>
                            <div className="hand-drawn-cloud">Drag cards</div>
                          </>
                        )}
                      </div>
                    );
                  })}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
